import { render } from "./SettingsHelpModal.vue?vue&type=template&id=6601c4aa&scoped=true"
import script from "./SettingsHelpModal.vue?vue&type=script&lang=js"
export * from "./SettingsHelpModal.vue?vue&type=script&lang=js"

import "./SettingsHelpModal.vue?vue&type=style&index=0&id=6601c4aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6601c4aa"]])

export default __exports__